/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import {
  isMobile,
  isTWA,
} from '@linc-technologies/linced-common/utils/platform';

export default class ProfileMenu extends Component {
  @service
  session;

  @service
  permissions;

  @service
  router;

  @service
  pushNotifications;

  @computed('session.scopes.[]')
  get showSubscriptionManager() {
    let isStaff = this.permissions.meet(Scopes.TENANT_STAFF);
    let isLincEd = this.permissions.meet(Scopes.LINCED_MANAGER);
    return isStaff && !isLincEd;
  }

  @action
  navigateTo(route, menu) {
    this.router.transitionTo(route);
    menu.actions.close();
  }

  /**
   * logout clears out the users session on logout.
   *
   * If a mobile device, will also remove the device from the user in order
   * to stop push notifications.
   */
  @action
  logout() {
    if (isMobile() || isTWA()) {
      // We need to detach the device from the database before logging out,
      // so that the user no longer receives device notifications.
      //
      // If we invalidate before detaching, there is no longer an auth token
      // which we can use to detach the device.
      return this.pushNotifications.detachDevice(this.session.personId, () => {
        this.session.logout('profileMenu');
      });
    }
    this.session.logout('profileMenu');
  }
}
